import { render, staticRenderFns } from "./ApplicationEducationTransfer.vue?vue&type=template&id=a9f79314&scoped=true&"
import script from "./ApplicationEducationTransfer.vue?vue&type=script&lang=js&"
export * from "./ApplicationEducationTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f79314",
  null
  
)

export default component.exports